var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Bootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 5 L 5 27 L 27 27 L 27 5 L 5 5 z M 7 7 L 25 7 L 25 25 L 7 25 L 7 7 z M 11 10 L 11 15.509766 L 11 21.990234 C 16.93 21.990234 18.116563 22.070234 19.226562 21.740234 C 19.876562 21.540234 21.65625 20.900391 21.65625 18.650391 C 21.65625 17.650391 21.356484 15.959062 19.396484 15.539062 L 19.396484 15.509766 L 19.027344 15.509766 C 20.027344 15.059766 20.65625 14.210937 20.65625 12.960938 C 20.65625 12.640937 20.746094 10 17.246094 10 L 11 10 z M 13 12 L 17 12 C 18.509 12 18.65625 12.853234 18.65625 13.490234 C 18.65625 15.044234 17.03 15 17 15 L 13 15 L 13 12 z M 13 17 L 17.759766 17 C 19.620766 17 19.65625 18.176469 19.65625 18.480469 C 19.65625 20.040469 18.044609 20 17.849609 20 L 13 20 L 13 17 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Bootstrap);
export default __webpack_public_path__ + "static/media/icons8-bootstrap.92e5321d46b53e402ee113b3f4d72c45.svg";
export { ForwardRef as ReactComponent };